<script lang="ts">
  import LogIn from '../Users/LogIn.svelte'
  import EmailSignUpForm from '../Users/EmailSignUpForm.svelte'
  import EmailSignInForm from '../Users/EmailSignInForm.svelte'
  type PageState = 'Google' | 'Email' | 'CreateEmail'
  let state: PageState = 'Google'
</script>

{#if state === 'Google'}
  <p>Sign in with your Google account to start using the TSF Retro app.</p>
  <LogIn />
  <a href="#email" on:click={() => (state = 'Email')}>Sign in with email</a>
{:else if state === 'Email'}
  <EmailSignInForm />
  <a href="#create-email-user" on:click={() => (state = 'CreateEmail')}>Create an Account</a>
{:else}
  <EmailSignUpForm />
  <a href="#email" on:click={() => (state = 'Google')}>Back</a>
{/if}
